import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-account-noty',
  templateUrl: './account-noty-modal.component.html',
  styleUrls: ['./account-noty-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountNotyComponent {
  constructor(private dialogRef: MatDialogRef<AccountNotyComponent>) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
